var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inward"
  }, [(_vm.showeye1 == true) ? _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [(_vm.css1) ? _c('div', {
    staticStyle: {
      "margin-top": "-4px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.boxPacking')))])])]) : _vm._e(), _vm._v(" "), (_vm.css2) ? _c('div', {
    staticStyle: {
      "margin-top": "-6px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.boxPacking')))])]), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "top": "0px",
      "left": "118px"
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.orderOrigin')) + ":\n              "), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderType))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "171px",
      "top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.clientName')) + " :\n              "), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.clientName))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.css3) ? _c('div', {
    staticStyle: {
      "margin-top": "-14px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.boxPacking')))])]), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "top": "0px",
      "left": "118px"
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.orderOrigin')) + "\n              :\n              "), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderType))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "172px",
      "top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.clientName')) + "\n              :"), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.clientName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showButtonManualPacking) ? _c('span', {
    staticClass: "testing",
    staticStyle: {
      "left": "238px",
      "top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.manualPacking')))]) : _vm._e(), _vm._v(" "), (_vm.showButtonManualPacking) ? _c('label', {
    staticClass: "switch",
    staticStyle: {
      "left": "208px",
      "top": "10px"
    }
  }, [_c('input', {
    attrs: {
      "size": "sm",
      "id": "manualPackingEnable",
      "type": "checkbox"
    },
    on: {
      "change": _vm.manualPackingEnable
    }
  }), _c('span', {
    staticClass: "slider round"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), (_vm.systemLoginCheck) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.boxId')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.boxId'),
      "name": "boxid",
      "id": "boxid",
      "min": "1"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getBoxDetails(0)
      }
    },
    model: {
      value: (_vm.finalObject.boxId),
      callback: function($$v) {
        _vm.finalObject.boxId = $$v
      },
      expression: "finalObject.boxId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxid')),
      expression: "errors.has('boxid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('boxid')))])], 1)], 1), _vm._v(" "), (_vm.finalObject.boxId) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.boxWeight')) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.boxId) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxweight')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.boxWeightPlaceHolder'),
      "value": "0",
      "name": "boxweight",
      "id": "boxweight"
    },
    model: {
      value: (_vm.finalObject.boxWeight),
      callback: function($$v) {
        _vm.finalObject.boxWeight = $$v
      },
      expression: "finalObject.boxWeight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxweight')),
      expression: "errors.has('boxweight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('boxweight')))])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.finalObject.boxId) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [(_vm.finalObject.showInvoiceButton && _vm.showInvoiceAndLabels) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "float": "left",
      "background-color": "#44b8bd"
    },
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "success",
      "disabled": _vm.isLoading || _vm.isLoadingFeild
    },
    on: {
      "click": function($event) {
        _vm.printInvoice()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('boxList.printInvoice')))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.showLabelButton && _vm.showInvoiceAndLabels) ? _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "left",
      "margin-left": "10px",
      "background-color": "rgb(117 175 66)",
      "color": "white"
    },
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "success",
      "disabled": _vm.isLoading || _vm.isLoadingFeild
    },
    on: {
      "click": function($event) {
        _vm.printLabel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('boxList.printLabel')))]) : _vm._e(), _vm._v(" "), (_vm.splitShimentEnable && !_vm.issingleQty && _vm.finalObject.orderType != 'CSV') ? _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("*Invoice will be generated after QC\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('common.resetBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "right",
      "margin-left": "10px",
      "color": "white"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.getWeight
    }
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('common.getWeightButton')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "id": "submitbtn",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getBoxDetails(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('boxList.getBoxDetailsButton')))])])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.showBoxDetails && _vm.finalObject.boxId && !_vm.allowPackingComplete && _vm.packingbox && !_vm.packingbox1 && _vm.issuggestionEnabled) ? _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.packingBoxSuggestion')))])])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.SystemSuggestedBox')) + " :")]), _vm._v("    \n                  " + _vm._s(_vm.packingboxname))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.selectBox')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sugestboxid),
      expression: "sugestboxid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('sugboxid')
    },
    attrs: {
      "name": "sugestboxid"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sugestboxid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sugestboxidSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.selectBox')))]), _vm._v(" "), _vm._l((_vm.listPackingBoxData), function(packingbox) {
    return _c('option', {
      domProps: {
        "value": packingbox.boxid
      }
    }, [_vm._v("\n                      " + _vm._s(packingbox.boxname))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('barcodesugestion')
    },
    attrs: {
      "type": "hidden",
      "placeholder": _vm.$t('boxList.barcodeBoxScan'),
      "name": "barcodesugestion",
      "id": "barcodesugestion"
    },
    on: {
      "change": _vm.barcodesugestionScanned
    },
    model: {
      value: (_vm.barcodesugestion),
      callback: function($$v) {
        _vm.barcodesugestion = $$v
      },
      expression: "barcodesugestion"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('barcodesugestion')),
      expression: "errors.has('barcodesugestion')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('barcodesugestion')))])], 1)], 1), _vm._v(" "), (_vm.boxchange) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.reasonforBoxChange')))])]) : _vm._e(), _vm._v(" "), (_vm.boxchange) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.overidereason),
      expression: "overidereason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('sugboxid')
    },
    attrs: {
      "name": "overidereason"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.overidereason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.overidereasonSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.selectOverideReason')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Box not suitable"
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxNotSuitable')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.other')))])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('overidereason')),
      expression: "errors.has('overidereason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('overidereason')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.boxchange && _vm.otherreason1) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxweight')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('boxList.otherReason'),
      "name": "otherreason",
      "id": "otherreason"
    },
    model: {
      value: (_vm.otherreason),
      callback: function($$v) {
        _vm.otherreason = $$v
      },
      expression: "otherreason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('otherreason')),
      expression: "errors.has('otherreason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('otherreason')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.SaveBoxSugestion(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.saveBoxSuggestion')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails && _vm.finalObject.boxId && !_vm.allowPackingComplete && _vm.packedbox && _vm.packingbox && !_vm.packingbox1 && _vm.issuggestionEnabled) ? _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.packingBox')) + " ")])])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.SystemSuggestedBox')) + "\n                    :")])]), _vm._v("   " + _vm._s(_vm.packingboxname) + "\n              ")]), _vm._v(" "), (_vm.suggestedpackbox) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.selectedBox')) + " :")])]), _vm._v("   " + _vm._s(_vm.suggestedpackbox) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.packboxchangereason) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.reasonforBoxChange')) + " :")])]), _vm._v("    " + _vm._s(_vm.packboxchangereason) + "\n              ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails && _vm.finalObject.boxId && _vm.packingbox1) ? _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.orderID')) + " : "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderId))])]), _vm._v(" "), _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('boxList.orderType')) + ":\n              "), (this.finalObject.btoborder == 1) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v("B2B Order")]) : _vm._e(), _vm._v(" "), (this.finalObject.btoborder == 0) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v("B2C Order")]) : _vm._e()]), _vm._v(" "), (_vm.finalObject.orderShiByDate) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "5px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.shipByDate')) + " : "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(_vm.dateFormatDetail(this.finalObject.orderShiByDate)))])]) : _vm._e()]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.orderQuantity')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.showPackingCompleteButton) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.totalOrderQty))])]) : _vm._e(), _vm._v(" "), (!_vm.showPackingCompleteButton) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "11px"
    }
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.totalOrderQty))])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [(_vm.showPackingCompleteButton) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxSku')) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxQuantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxQtyCancelled')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.showPackingCompleteButton) ? _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.totalSkus))])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("\n                            " + _vm._s(_vm.finalObject.totalQty) + "\n                          ")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(this.finalObject.cancelQty))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [(_vm.finalObject.merchantName) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.merchant')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shipmentId) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shipmentId')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.salesChannel) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.awbNo) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shippingCourierCompany) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.ShippingProvider')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.courierName) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.selfShipped')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center cardreporttabletr"
  }, [(_vm.finalObject.merchantName) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.merchantName))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shipmentId) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.shipmentId))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.salesChannel) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.salesChannel))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.awbNo) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.awbNo))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shippingCourierCompany) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.courierName))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shippingCourierCompany) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.shippingCourierCompany))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.courierName && !_vm.finalObject.shippingCourierCompany) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.finalObject.courierName))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.orderSelfshipped) ? _c('td', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (!_vm.finalObject.orderSelfshipped) ? _c('td', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("No")]) : _vm._e()])])])]), _vm._v(" "), (_vm.showPackingCompleteButton) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [(this.finalObject.btoborder == 1) ? _c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.productQCDetails')))])]) : _c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.productQCDetails')))])]), _vm._v(" "), _c('tr', [(this.finalObject.btoborder == 1) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('boxList.totalPick')))]) : _vm._e(), _vm._v(" "), (this.finalObject.btoborder == 1) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('boxList..totalQCDone')))]) : _vm._e(), _vm._v(" "), (this.finalObject.btoborder == 1) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('boxList.totalPendingQC')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.totalQCAcceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.totalQCRejectedQty')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(this.finalObject.btoborder == 1) ? _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.pickqty))])]) : _vm._e(), _vm._v(" "), (this.finalObject.btoborder == 1) ? _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.qtyQcAccept +
    this.finalObject.qtyQcReject))])]) : _vm._e(), _vm._v(" "), (this.finalObject.btoborder == 1) ? _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.pickqty -
    (this.finalObject.qtyQcAccept + this.finalObject.qtyQcReject)))])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.qtyQcAccept))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_c('p', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(this.finalObject.qtyQcReject))])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.cancelQty > 0) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.cancelledQuantityDetails')))])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.productID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.rackID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.quantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.pickedQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.cancelledQuantity')))])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.finalObject.cancelProductDetails), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pickqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.cancelqty))])])
  }))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails && _vm.finalObject.boxId && _vm.packingbox1) ? _c('b-card', [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-evenly"
    },
    slot: "header"
  }, [(!_vm.allowPackingComplete && (_vm.finalObject.b2b_qc_done == 0 || _vm.finalObject.b2b_qc_done == 1)) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "color": "green"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.scanProduct')))])]) : _vm._e(), _vm._v(" "), (!_vm.allowPackingComplete && _vm.finalObject.b2b_qc_done == 2) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "color": "green"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.qcDone')))])]) : _vm._e(), _vm._v(" "), (_vm.allowPackingComplete) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "color": "green"
    }
  }, [(_vm.finalObject.boxStatus && _vm.finalObject.boxStatus == 'in_picking') ? _c('b', [_vm._v(_vm._s(_vm.$t('boxList.inPicking')))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.boxStatus && _vm.finalObject.boxStatus == 'in_packing') ? _c('b', [_vm._v(_vm._s(_vm.$t('boxList.inPacking')))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.boxStatus && _vm.finalObject.boxStatus == 'in_shipping') ? _c('b', [_vm._v(_vm._s(_vm.$t('boxList.packingCompleted')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "11px",
      "top": "-3px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('boxList.boxStatus')) + " : "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.boxStatus))])]), _vm._v(" "), _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "60px",
      "top": "-3px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.orderStatus')) + " : "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderStatus))])]), _vm._v(" "), (_vm.finalObject.shipmentStatus) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "109px",
      "top": "-3px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('orders.shipementStatus')) + " : "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.shipmentStatus))])]) : _vm._e()]), _vm._v(" "), (_vm.showPackingCompleteButton && _vm.showQCAndPackingSection) ? _c('fieldset', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingFeild
    }
  }), _vm._v(" "), (!_vm.allowPackingComplete) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.productId),
      expression: "finalObject.productId"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productId'),
      "name": "productid",
      "id": "productid",
      "readonly": _vm.isReadonlyFlag == 0
    },
    domProps: {
      "value": (_vm.finalObject.productId)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.scanProduct($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalObject.productId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "id": "scanbtn1",
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.scanProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(_vm._s(_vm.$t('boxList.scan')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showProductQcDetails && !_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.finalObject.showQtyInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.productQty),
      expression: "finalObject.productQty"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('common.quantity'),
      "name": "productQty",
      "id": "productQty"
    },
    domProps: {
      "value": (_vm.finalObject.productQty)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalObject.productQty = $event.target.value
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductQcDetails && !_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.productQC('accept')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('common.accept')))]), _vm._v("  \n                  ")]) : _vm._e(), _vm._v(" "), (_vm.showProductQcDetails && !_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": true,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.productQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(_vm._s(_vm.$t('common.reject')))])]) : _vm._e(), _vm._v(" "), (_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    class: {
      'form-control': true
    },
    attrs: {
      "label": "value",
      "track-by": "value",
      "options": _vm.options,
      "multiple": true,
      "placeholder": _vm.$t('boxList.reasonPlaceholder'),
      "hide-selected": true,
      "name": "Reject Reason"
    },
    on: {
      "input": _vm.rejectedReasonsSelected
    },
    model: {
      value: (_vm.rejectReasons),
      callback: function($$v) {
        _vm.rejectReasons = $$v
      },
      expression: "rejectReasons"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.updateQcDetails('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(_vm._s(_vm.$t('common.reject')))])]) : _vm._e()])]), _vm._v(" "), (_vm.showProductQcDetails) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.finalObject.scanproductData.productimage) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productImage')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productname) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productName')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.brand) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.brand')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.size) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.size')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.color) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.color')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.mrp) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.mrp')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productcategory) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productCategory')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productdescription) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productDescription')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.finalObject.scanproductData.productimage) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.finalObject.scanproductData.productimage,
      "width": "100px",
      "height": "120px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productname) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("\n                          " + _vm._s(_vm.finalObject.scanproductData.productname))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.brand) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("\n                          " + _vm._s(_vm.finalObject.scanproductData.brand))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.size) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("\n                          " + _vm._s(_vm.finalObject.scanproductData.size))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.color) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("\n                          " + _vm._s(_vm.finalObject.scanproductData.color))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.mrp) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("\n                          " + _vm._s(_vm.finalObject.scanproductData.mrp))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productcategory) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("\n                          " + _vm._s(_vm.finalObject.scanproductData.productcategory))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productdescription) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("\n                          " + _vm._s(_vm.finalObject.scanproductData.productdescription))]) : _vm._e()])])])]), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.allowPackingComplete && !_vm.showSplitBoxData && !_vm.hideCourierAwbDetails) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-2.5"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.courierName),
      expression: "finalObject.courierName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('couriername')
    },
    attrs: {
      "name": "couriername",
      "id": "couriername"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.finalObject.courierName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.courierSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompanyPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.finalObject.salesChannelList), function(courier_obj) {
    return _c('option', {
      domProps: {
        "value": courier_obj.courierid
      }
    }, [_vm._v("\n                      " + _vm._s(courier_obj.couriername))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('couriername')),
      expression: "errors.has('couriername')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.$t('courierMapping.transportererr')))])], 1) : _vm._e(), _vm._v(" "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-2.5"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbno')
    },
    attrs: {
      "type": "text",
      "disabled": _vm.finalObject.xbEcomFlag || _vm.finalObject.isRubicon || _vm.finalObject.isWmall || _vm.finalObject.isMultiseller || _vm.finalObject.isUnicommerce || _vm.finalObject.isNimbus,
      "placeholder": _vm.$t('packingb2b.b2bPacking.modal.awbPlaceholder'),
      "name": "awbno",
      "id": "awbno"
    },
    model: {
      value: (_vm.finalObject.awbNo),
      callback: function($$v) {
        _vm.finalObject.awbNo = $$v
      },
      expression: "finalObject.awbNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbno')),
      expression: "errors.has('awbno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.awbNoError')))])], 1) : _vm._e(), _vm._v(" "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.completePacking
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('common.packingCompleted')))]) : _vm._e()]) : _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.completePacking
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('common.packingCompleted')))]) : _vm._e()]), _vm._v(" \n              "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.finalObject.btoborder == 1) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.qcDone
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('boxList.qcBoxDoneButton')))]) : _vm._e()]) : _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.finalObject.btoborder == 1) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.qcDone
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('boxList.qcBoxDoneButton')))]) : _vm._e()]), _vm._v("  \n            ")]) : _vm._e(), _vm._v(" "), (_vm.allowPackingComplete && !_vm.showSplitBoxData) ? _c('div', {
    staticClass: "form-group row my-4",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center"
    }
  }, [(_vm.splitShimentEnable && !_vm.hidesplitBoxbtn) ? _c('div', {
    staticClass: "col-md-1.5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#673AB7"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.splitBox
    }
  }, [_c('i', {
    staticClass: "fa fa-chain-broken"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('boxList.splitBox')))]), _vm._v("   \n              ")]) : _vm._e(), _vm._v(" "), (_vm.splitShimentEnable && !_vm.hideproceedWithOutSplit && _vm.finalObject.orderType != 'CSV') ? _c('div', {
    staticClass: "col-md-1.5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getBoxDetails(1)
      }
    }
  }, [_vm._v("\n                 Proceed Without Split")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showSplitBoxData) ? _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-evenly"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-container",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "scroll-container"
  }, [_c('table', [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.sourceBoxDetails')))])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.productEancode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.productQuantity')))])])])]), _vm._v(" "), _vm._l((_vm.sourceBoxData), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productqty))])])
  }), _vm._v(" "), (_vm.sourceBoxData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-container",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "scroll-container"
  }, [_c('table', [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.destinationBoxDetails')))])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.productEancode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.productQuantity')))])])])]), _vm._v(" "), _vm._l((_vm.destinationBoxData), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productqty))])])
  }), _vm._v(" "), (_vm.destinationBoxData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showSplitBoxData) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 my-3"
  }, [(!_vm.finalObject.issplited) ? _c('b-tabs', [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('product.addProduct'),
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.resetBoxData()
      }
    }
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('destinationBoxId')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.destinationBoxPlaceholder'),
      "name": "destinationBoxId",
      "id": "destinationBoxId",
      "min": "1"
    },
    model: {
      value: (_vm.destinationBoxId),
      callback: function($$v) {
        _vm.destinationBoxId = $$v
      },
      expression: "destinationBoxId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destinationBoxId')),
      expression: "errors.has('destinationBoxId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destinationBoxId')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#673AB7"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "id": "validateBoxbtn",
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.validateBox
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n                            " + _vm._s(_vm.$t('boxList.validateBox')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "id": "Resetbtn1",
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetBoxData
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('boxList.boxchange')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.productId),
      expression: "finalObject.productId"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('product.eanCode'),
      "name": "productid",
      "id": "productid"
    },
    domProps: {
      "value": (_vm.finalObject.productId)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.scanProduct($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalObject.productId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "id": "scanbtn2",
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.scanProduct(0, 1, 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(_vm._s(_vm.$t('boxList.scan')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button"
    },
    on: {
      "click": _vm.splitBoxfun
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('boxList.splitBox')))])])], 1)]), _vm._v(" "), (_vm.productDetails) ? _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "float": "right",
      "margin-top": "-130px"
    }
  }, [_c('div', [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "font-size": "14px",
      "left": "2px",
      "top": "-3px",
      "width": "480px",
      "color": "rgb(174 45 14)"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('boxList.productDetail')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [(_vm.productDetail && _vm.productDetail.length > 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.productDetail && _vm.productDetail[0] && _vm.productDetail[0].productimage) ? _c('img', {
    attrs: {
      "src": _vm.productDetail[0].productimage,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.productDetail && _vm.productDetail.length > 0) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.productId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].productid || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('common.productName')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].productname || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('common.eanCode')) + " :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].ean || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('removeHold.brand')) + " :")]), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].brand || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.color')) + " :")]), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].color || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.size')) + " :")]), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].size || 'N/A'))])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('product.removeProduct')
    },
    on: {
      "click": function($event) {
        _vm.resetBoxData()
      }
    }
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('destinationBoxId')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.destinationBoxPlaceholder'),
      "name": "destinationBoxId1",
      "id": "destinationBoxId1",
      "min": "1"
    },
    model: {
      value: (_vm.destinationBoxId),
      callback: function($$v) {
        _vm.destinationBoxId = $$v
      },
      expression: "destinationBoxId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destinationBoxId')),
      expression: "errors.has('destinationBoxId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destinationBoxId')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#673AB7"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "id": "validateBoxbtn1",
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.validateBox
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n                            " + _vm._s(_vm.$t('boxList.validateBox')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "id": "Resetbtn",
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetBoxData
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('boxList.boxchange')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.productId),
      expression: "finalObject.productId"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('product.eanCode'),
      "name": "productid",
      "id": "productid"
    },
    domProps: {
      "value": (_vm.finalObject.productId)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.scanProduct($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalObject.productId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "id": "scanbtn",
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.scanProduct(1, 1, 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(_vm._s(_vm.$t('boxList.scan')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button"
    },
    on: {
      "click": _vm.splitBoxfun
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('boxList.splitBox')))])])])]), _vm._v(" "), (_vm.productDetails) ? _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "float": "right",
      "margin-top": "-130px"
    }
  }, [_c('div', [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "font-size": "14px",
      "left": "2px",
      "top": "-3px",
      "width": "480px",
      "color": "rgb(174 45 14)"
    }
  }, [_c('b', [_vm._v("  " + _vm._s(_vm.$t('boxList.productDetail')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [(_vm.productDetail && _vm.productDetail.length > 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('img', {
    attrs: {
      "src": _vm.productDetail[0].productimage,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "load": function($event) {
        _vm.myevent()
      },
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.productDetail && _vm.productDetail.length > 0) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.productId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].productid || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('common.productName')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].productname || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('common.eanCode')) + " :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].ean || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('removeHold.brand')) + " :")]), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].brand || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.color')) + " :")]), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].color || 'N/A'))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.size')) + " :")]), _c('span', [_vm._v(_vm._s(_vm.productDetail[0].size || 'N/A'))])]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.showBoxDetails && _vm.finalObject.boxId && !_vm.isSuggestionPresent && _vm.showBoxSuggestionSplit && _vm.issuggestionEnabled) ? _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.SystemSuggestedBox')) + " :")]), _vm._v("    \n                          " + _vm._s(_vm.packingboxname))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.selectBox')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sugestboxid),
      expression: "sugestboxid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('sugboxid')
    },
    attrs: {
      "name": "sugestboxid",
      "id": "sugestboxid"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sugestboxid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sugestboxidSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.selectBox')))]), _vm._v(" "), _vm._l((_vm.listPackingBoxData), function(packingbox) {
    return _c('option', {
      domProps: {
        "value": packingbox.boxid
      }
    }, [_vm._v("\n                              " + _vm._s(packingbox.boxname))])
  })], 2)])], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('barcodesugestion')
    },
    attrs: {
      "type": "hidden",
      "placeholder": _vm.$t('boxList.barcodeBoxScan'),
      "name": "barcodesugestion",
      "id": "barcodesugestion"
    },
    on: {
      "change": _vm.barcodesugestionScanned
    },
    model: {
      value: (_vm.barcodesugestion),
      callback: function($$v) {
        _vm.barcodesugestion = $$v
      },
      expression: "barcodesugestion"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('barcodesugestion')),
      expression: "errors.has('barcodesugestion')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('barcodesugestion')))])], 1), _vm._v(" "), (_vm.boxchange) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.reasonforBoxChange')))])]) : _vm._e(), _vm._v(" "), (_vm.boxchange) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.overidereason),
      expression: "overidereason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('sugboxid')
    },
    attrs: {
      "name": "overidereason",
      "id": "overidereason"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.overidereason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.overidereasonSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.selectOverideReason')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Box not suitable"
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxNotSuitable')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.other')))])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('overidereason')),
      expression: "errors.has('overidereason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('overidereason')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.boxchange && _vm.otherreason1) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxweight')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('boxList.otherReason'),
      "name": "otherreason",
      "id": "otherreason2"
    },
    model: {
      value: (_vm.otherreason),
      callback: function($$v) {
        _vm.otherreason = $$v
      },
      expression: "otherreason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('otherreason')),
      expression: "errors.has('otherreason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('otherreason')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.SaveBoxSugestion(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.saveBoxSuggestion')))])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails && _vm.finalObject.boxId && _vm.isSuggestionPresent && _vm.showBoxSuggestionSplit && _vm.issuggestionEnabled) ? _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.packingBox')) + " ")])])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.SystemSuggestedBox')) + "\n                            :")])]), _vm._v("   " + _vm._s(_vm.packingboxname) + "\n                      ")]), _vm._v(" "), (_vm.suggestedpackbox) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.selectedBox')) + " :")])]), _vm._v("   " + _vm._s(_vm.suggestedpackbox) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.packboxchangereason) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.reasonforBoxChange')) + " :")])]), _vm._v("    " + _vm._s(_vm.packboxchangereason) + "\n                      ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.showSplitBoxPacking && _vm.showBoxSuggestionSplit) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-2.5"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.courierName),
      expression: "finalObject.courierName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('couriername')
    },
    attrs: {
      "name": "couriername",
      "id": "couriername1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.finalObject.courierName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.courierSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompanyPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.finalObject.salesChannelList), function(courier_obj) {
    return _c('option', {
      domProps: {
        "value": courier_obj.courierid
      }
    }, [_vm._v("\n                            " + _vm._s(courier_obj.couriername))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('couriername')),
      expression: "errors.has('couriername')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.$t('courierMapping.transportererr')))])], 1) : _vm._e(), _vm._v(" "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-2.5"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbno')
    },
    attrs: {
      "type": "text",
      "disabled": _vm.finalObject.xbEcomFlag || _vm.finalObject.isRubicon || _vm.finalObject.isWmall || _vm.finalObject.isMultiseller || _vm.finalObject.isUnicommerce || _vm.finalObject.isNimbus,
      "placeholder": _vm.$t('packingb2b.b2bPacking.modal.awbPlaceholder'),
      "name": "awbno",
      "id": "awbno1"
    },
    model: {
      value: (_vm.finalObject.awbNo),
      callback: function($$v) {
        _vm.finalObject.awbNo = $$v
      },
      expression: "finalObject.awbNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbno')),
      expression: "errors.has('awbno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.awbNoError')))])], 1) : _vm._e(), _vm._v(" "), (_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "id": "packingCompleted",
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.completePacking
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('common.packingCompleted')))]) : _vm._e()]) : _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.finalObject.btoborder == 0 || _vm.finalObject.btoborder == null || this.finalObject.btoborder == '') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "id": "packingCompleted1",
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.completePacking
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('common.packingCompleted')))]) : _vm._e()]), _vm._v(" \n\n\n                  ")], 1) : _vm._e()], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showPackdata) ? _c('fieldset', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingFeild
    }
  }), _vm._v(" "), (_vm.showPackdata) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.PrintPackdata(_vm.finalObject)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(_vm._s(_vm.$t('boxList.packingSlip')))])]) : _vm._e()], 1) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": _vm.$t('pincodemapping.confirmation')
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pincodemapping.confirmation')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('boxList.doneQC')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.changeBoxStatus, function($event) {
        _vm.modalShow = false
      }]
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('common.done')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(_vm._s(_vm.$t('printProductDetails.cancel')))])])])])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showeye1 == false) ? _c('div', [_c('div', [_c('printpackdata', {
    attrs: {
      "filterData": _vm.filterData,
      "pono1": _vm.selectedRow
    },
    on: {
      "goBackToParent": _vm.callParent1
    }
  })], 1)]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c8d7b514", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8d7b514","hasScoped":true}!./src/views/components/packingnew/packingnew.component.html
// module id = 1945
// module chunks = 0